import type { RouteRecordRaw, Router } from 'vue-router'

const FinancialClaimRoutes: RouteRecordRaw = {
  path: '/claim/financialClaim',
  name: 'FinancialClaimModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'FinancialClaimMainRoute',
      component: () => import('./views/FinancialView.vue'),
      meta: {
        title: 'financialClaim.financialClaim',
      },
    },
    {
      path: 'create',
      name: 'FinancialClaimCreateRoute',
      component: () => import('./views/FinancialUpsertView.vue'),
      meta: {
        title: 'financialClaim.createFinancialClaim',
        pageHasBack: true,
      },
    },
    {
      path: 'edit/:financialClaimId',
      name: 'FinancialClaimEditRoute',
      component: () => import('./views/FinancialUpsertView.vue'),
      meta: {
        title: 'financialClaim.editFinancialClaim',
        pageHasBack: true,
      },
    },
    {
      path: 'view/:financialClaimId',
      name: 'ViewFinancialClaimRoute',
      component: () => import('./views/SingleFinancialView.vue'),
      meta: {
        title: 'financialClaim.ViewFinancialClaim',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
  },
}

export default (router: Router) => {
  router.addRoute(FinancialClaimRoutes)
}
